import * as React from "react";
import { connect } from "react-redux";
import { style } from "typestyle";
import { IPrescanState } from "../redux/modules/prescan/reducer";
import SidebarHeader from "./Generics/SidebarHeader";
import { getPrescanState } from "../redux/rootReducer";
import config from "../config";

export interface IProps {
  scanState: IPrescanState;
  rightIcon?: React.ReactNode;
  onRightIconClick?: () => void;
}

const months = [
  config.language === "ru" ? "янв" : "Jan",
  config.language === "ru" ? "фев" : "Feb",
  config.language === "ru" ? "мар" : "Mar",
  config.language === "ru" ? "апр" : "Apr",
  config.language === "ru" ? "мая" : "May",
  config.language === "ru" ? "июн" : "Jun",
  config.language === "ru" ? "июл" : "Jul",
  config.language === "ru" ? "авг" : "Aug",
  config.language === "ru" ? "сен" : "Sep",
  config.language === "ru" ? "окт" : "Oct",
  config.language === "ru" ? "ноя" : "Nov",
  config.language === "ru" ? "дек" : "Dec",
];

const ScanDateBar: React.FC<IProps> = ({
  scanState,
  rightIcon,
  onRightIconClick,
}: IProps) => {
  if (!scanState.data) {
    return null;
  }

  const dt = new Date(scanState.data.doneDate);

  return (
    <SidebarHeader
      leftIcon={
        <div
          className={style({
            fontSize: 22,
            fontWeight: "bold",
            color: "white",
          })}
        >
          {dt.getDate()}
        </div>
      }
      leftLabel={
        <div className={style({ fontSize: 16, color: "white" })}>
          {months[dt.getMonth()]}
        </div>
      }
      rightIcon={rightIcon || null}
      onRightIconClick={onRightIconClick || null}
    />
  );
};

export default connect((state: any) => ({
  scanState: getPrescanState(state),
}))(ScanDateBar);
